import React from 'react';

function IconSearch(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={props.className} aria-hidden>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.2-4.2" strokeLinecap="round" />
    </svg>
  );
}

function IconMic(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={props.className} aria-hidden>
      <path d="M12 14a3 3 0 003-3V5a3 3 0 10-6 0v6a3 3 0 003 3zm5-3a5 5 0 01-10 0H5a7 7 0 0014 0h-2zm-5 3v4h-2v-4h2z" />
    </svg>
  );
}

function IconCart({ className }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={className} aria-hidden>
      <path d="M6 6h15l-1.5 9H7.5L6 6z" strokeLinejoin="round" />
      <path d="M6 6L5 3H2" strokeLinecap="round" />
      <circle cx="9" cy="20" r="1" fill="currentColor" stroke="none" />
      <circle cx="18" cy="20" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconUser(props) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className={props.className} aria-hidden>
      <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" strokeLinecap="round" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}

export default function StoreTopHeader({
  searchValue,
  onSearchChange,
  cartCount,
  onCartClick,
  onAdminClick,
  searchPlaceholder = 'Search'
}) {
  return (
    <header className="border-b border-slate-200 bg-white shadow-sm">
      <div className="mx-auto grid max-w-7xl grid-cols-[minmax(0,1fr)_auto] items-center gap-3 px-3 py-3 sm:flex sm:gap-6 sm:px-6 sm:py-4 lg:px-8">
        <div className="min-w-0 shrink-0">
          <div className="inline-flex max-w-full rounded-xl bg-white p-1.5 shadow-md ring-1 ring-slate-200 sm:p-2">
            <img src="/logo.png" alt="Store logo" className="h-9 w-auto max-w-[170px] object-contain sm:h-11 sm:max-w-[220px]" />
          </div>
        </div>

        <div className="order-3 col-span-2 flex min-w-0 flex-1 justify-center sm:order-none sm:col-span-1">
          <div className="relative w-full max-w-2xl">
            <label className="sr-only" htmlFor="store-search">
              Search products
            </label>
            <div className="flex min-h-[46px] items-center gap-1.5 rounded-2xl border-2 border-slate-200 bg-slate-50/80 pl-2 pr-2 shadow-inner transition focus-within:border-[#5c2d91]/50 focus-within:bg-white focus-within:ring-2 focus-within:ring-[#5c2d91]/20 sm:gap-2 sm:rounded-full sm:pl-3">
              <button
                type="button"
                className="shrink-0 rounded-full p-2 text-slate-400 hover:bg-white hover:text-[#5c2d91]"
                aria-label="Voice search (coming soon)"
                title="Voice search coming soon"
              >
                <IconMic className="h-5 w-5" />
              </button>
              <input
                id="store-search"
                type="search"
                placeholder={searchPlaceholder}
                className="min-w-0 flex-1 border-0 bg-transparent py-2.5 text-base text-slate-900 placeholder:text-slate-400 focus:outline-none focus:ring-0 sm:py-3"
                value={searchValue}
                onChange={(e) => onSearchChange(e.target.value)}
                autoComplete="off"
              />
              <div className="flex shrink-0 items-center rounded-xl bg-[#5c2d91] p-2.5 text-white shadow-sm sm:rounded-full">
                <IconSearch className="h-5 w-5" />
              </div>
            </div>
          </div>
        </div>

        <div className="flex shrink-0 items-center justify-end gap-1 sm:gap-2">
          <button
            type="button"
            onClick={onCartClick}
            className="relative flex min-h-11 min-w-11 items-center justify-center rounded-full p-2 text-slate-600 hover:bg-slate-100 hover:text-[#5c2d91] touch-manipulation sm:min-h-0 sm:min-w-0"
            aria-label={`Shopping cart, ${cartCount} items`}
          >
            <IconCart className="h-6 w-6" />
            {cartCount > 0 ? (
              <span className="absolute -right-0.5 -top-0.5 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-[#8cc63f] px-1 text-[10px] font-bold text-slate-900">
                {cartCount > 99 ? '99+' : cartCount}
              </span>
            ) : null}
          </button>
          <button
            type="button"
            onClick={onAdminClick}
            className="flex min-h-11 min-w-11 items-center justify-center rounded-full p-2 text-slate-600 hover:bg-slate-100 hover:text-[#5c2d91] touch-manipulation sm:min-h-0 sm:min-w-0"
            aria-label="Employee portal"
            title="Employee portal"
          >
            <IconUser className="h-6 w-6" />
          </button>
        </div>
      </div>
    </header>
  );
}
